import { scrollTop } from '@utils/dom';
import { useEffect } from 'react';

export const useScrollTop = () => {
    useEffect(() => {
        scrollTop()
    }, [])
};